import API from "../utility/axios";
const apiUrl = "/api/v2";

export const GET_RUN_CRON_JOB = (data?: any): Promise<any> => {
  return API.get(`${apiUrl}/cron/jobs/institute/dashboard/stats`, {
    params: data,
  });
};
